export const DATADOG_RUM_FOR_DEV = 'datadogRumForDev';
